import { __assign } from "tslib";

var AbstractRenderer =
/** @class */
function () {
  function AbstractRenderer(config) {
    this.plugins = [];
    this.config = __assign({
      /**
       * enable auto rendering by default
       */
      enableAutoRendering: true,

      /**
       * enable dirty rectangle rendering by default
       */
      enableDirtyRectangleRendering: true,
      enableDirtyRectangleRenderingDebug: false,
      enableTAA: false
    }, config);
  }

  AbstractRenderer.prototype.registerPlugin = function (plugin) {
    this.plugins.push(plugin);
  };

  AbstractRenderer.prototype.getPlugins = function () {
    return this.plugins;
  };

  AbstractRenderer.prototype.getConfig = function () {
    return this.config;
  };

  AbstractRenderer.prototype.setConfig = function (config) {
    Object.assign(this.config, config);
  };

  return AbstractRenderer;
}();

export { AbstractRenderer };